// build url queries manually to avoid automatic url encode by router.{push,replace}
export const buildRouteParams = (path: string, queryKeyValues: Record<string, string>): [string, string] => {
  const queryString = Object.entries(queryKeyValues)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return [path + (queryString ? `?${queryString}` : ''), path + `.html` + (queryString ? `?${queryString}` : '')];
};
